import { Grid, Typography, Autocomplete, Button } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import MiniDrawer from "../../Components/Drawer";
import FormControl from "@mui/material/FormControl";
import BaseColor from "../../Config/Color";
import { getApiData } from "../../Apis/apiHelper";
import BaseSetting from "../../Apis/setting";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { FontFamily } from "../../Config/theme";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import CInput from "../../Components/CInput";
import { Editor } from "@tinymce/tinymce-react";
import CButton from "../../Components/CButton";
import TextField from "@mui/material/TextField";
import Chip from "@mui/material/Chip";
import CloseIcon from "@mui/icons-material/Close";

const BulkMail = () => {
  const editorRefApp = useRef(null);

  useEffect(() => {
    getAllBulkEmailApiCall(1);
  }, []);

  const [radioValue, setRadioValue] = useState("all");
  const [emailsList, setEmailsList] = useState();
  const [subject, setSubject] = useState("");
  const [disableBtn, setDisableBtn] = useState(false);
  const [btnLoad, setBtnLoad] = useState(false);
  const [EmailSend, setEmailSend] = useState([]);
  const [readOnly, setReadOnly] = useState(true);

  //validation
  const [templateNameErrorText, setTemplateNameErrorText] = useState("asas");
  const [subjectErrorText, setSubjectErrorText] = useState("");
  const [contentErrorText, setContentErrorText] = useState("");

  useEffect(() => {}, [EmailSend]);

  useEffect(() => {
    allErrorFalse();
    allTextClear();
  }, [radioValue]);

  //all email template data
  const getAllBulkEmailApiCall = (page, bool = false) => {
    getApiData(BaseSetting.endpoint.GetSubscribeEmails, "get")
      .then((result) => {
        if (result?.status) {
          const response = result?.data;
          if (!isEmpty(response)) {
            const extractedEmails = response?.map((val) => val?.email);
            setEmailsList(extractedEmails);
            setReadOnly(false);
          }
        } else {
          toast(result?.message, { type: "error" });
        }
      })
      .catch((err) => {
        toast(err?.message, { type: "error" });
      });
  };

  const handleInputChange = (_, newValue) => {
    const isValidEmail = /\S+@\S+\.\S+/.test(newValue[newValue.length - 1]);
    if (isValidEmail) {
      setEmailSend(newValue);
    } else {
      console.log("Please enter a valid email");
      console.log(newValue.pop());
    }
  };

  const validation = () => {
    const content = editorRefApp.current.getContent();
    if (subject.trim() === "") {
      allErrorFalse();
      setSubjectErrorText("Subject is required");
    } else if (content.trim() === "") {
      allErrorFalse();
      setContentErrorText("Content is required");
    } else if (
      radioValue === "specific" &&
      (EmailSend === "undefined" || EmailSend.length === 0)
    ) {
      allErrorFalse();
      setTemplateNameErrorText("Email  is required");
    } else {
      allErrorFalse();
      sendBulkMail();
    }
  };

  // send bulk mail api call
  const sendBulkMail = () => {
    const content = editorRefApp.current.getContent();
    setBtnLoad(true);
    setDisableBtn(true);

    const endpoint = BaseSetting.endpoint.SendBulkEmails;

    let data = {
      title: subject,
      description: content,
      type: radioValue === "all" ? "all" : "specific",
      emails: EmailSend,
    };

    getApiData(endpoint, "POST", data)
      .then((result) => {
        if (result?.status) {
          toast(result?.message, { type: "success" });
          setBtnLoad(false);
          setDisableBtn(false);
          allTextClear();
        } else {
          toast(result?.message, { type: "error" });
          setBtnLoad(false);
          setDisableBtn(false);
        }
      })
      .catch((err) => {
        toast(err?.message, { type: "error" });
        setBtnLoad(false);
        setDisableBtn(false);
      });
  };

  const allErrorFalse = () => {
    setTemplateNameErrorText("");
    setSubjectErrorText("");
    setContentErrorText("");
  };
  const allTextClear = () => {
    setSubject("");
    setEmailSend([]);
    editorRefApp?.current?.setContent("");
  };
  const handleChipDelete = (chipToDelete) => () => {
    setEmailSend((chips) => chips.filter((chip) => chip !== chipToDelete));
  };

  return (
    <Grid container>
      <MiniDrawer
        header="Bulk Mail"
        children={
          <>
            <Grid container mt={"30px"}>
              <FormControl>
                <FormLabel id="demo-row-radio-buttons-group-label">
                  Email for
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={radioValue}
                  onChange={(e) => setRadioValue(e.target.value)}
                >
                  <FormControlLabel
                    value="all"
                    control={<Radio />}
                    label="All"
                  />
                  <FormControlLabel
                    value="specific"
                    control={<Radio />}
                    label="Specific"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid container mt={"30px"} item xs={12} md={12} lg={12}>
              {radioValue === "specific" ? (
                <Grid mb={"30px"} item xs={12} md={12} lg={12}>
                  <Autocomplete
                    multiple
                    id="tags-standard"
                    options={emailsList}
                    value={EmailSend}
                    freeSolo
                    readOnly={readOnly}
                    onChange={handleInputChange}
                    renderTags={(value) =>
                      EmailSend.map((option, index) => (
                        <Grid>
                          <Chip
                            sx={{ mr: 1, backgroundColor: "#D9D9D9" }}
                            variant="outlined"
                            label={option}
                            onDelete={handleChipDelete(option)}
                            deleteIcon={
                              <CloseIcon sx={{ color: "#FF1010 !important" }} />
                            }
                          />
                        </Grid>
                      ))
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder={
                          readOnly ? "Fetching Email" : "Enter Or Select Email"
                        }
                      />
                    )}
                  />
                  {radioValue === "specific" ? (
                    <p style={{ color: "#FF1010", margin: 0 }}>
                      {templateNameErrorText}
                    </p>
                  ) : null}
                </Grid>
              ) : null}

              <Grid item xs={12} md={12} lg={12}>
                <CInput
                  placeholder="Subject"
                  value={subject}
                  onChange={(val) => {
                    setSubject(val);
                    setSubjectErrorText("");
                  }}
                  errorMsg={subjectErrorText}
                />
              </Grid>
              <Grid item xs={12} md={12} lg={12}>
                <Typography
                  style={{
                    margin: "30px 0px 5px 10px",
                    fontFamily: FontFamily.SemiBold,
                    fontSize: 15,
                  }}
                >
                  Content
                </Typography>
                <Editor
                  apiKey={BaseSetting?.tinymceEditorApiKey}
                  onInit={(evt, editor) => (editorRefApp.current = editor)}
                  plugins={"image code"}
                  init={{
                    height: 500,
                    plugins: [
                      "advlist autolink lists link image charmap print preview anchor",
                      "searchreplace visualblocks code fullscreen",
                      "insertdatetime media table paste code help wordcount image code",
                    ],
                    toolbar:
                      "undo redo | formatselect | " +
                      "bold italic backcolor | alignleft aligncenter " +
                      "alignright alignjustify | bullist numlist outdent indent image | " +
                      "removeformat | image | code",
                    images_upload_url: `${
                      BaseSetting?.serverUrl +
                      BaseSetting?.endpoint?.imageUpload
                    }`,
                  }}
                  onEditorChange={(content, editor) => {}}
                />
                <Typography
                  style={{
                    fontSize: 14,
                    color: BaseColor.errorRed,
                    fontFamily: FontFamily.Medium,
                    marginTop: "10px",
                  }}
                >
                  {contentErrorText}
                </Typography>
              </Grid>
              <Grid container gap={2} wrap="nowrap">
                <Grid item xs={4}>
                  <CButton
                    onClick={() => validation()}
                    fullWidth
                    variant="contained"
                    disabled={disableBtn}
                    loading={btnLoad}
                  >
                    Send
                  </CButton>
                </Grid>
              </Grid>
            </Grid>
          </>
        }
      />
    </Grid>
  );
};

export default BulkMail;
